// src/eh/demoMode.js
// ─────────────────────────────────────────────────────────────────────────────
// The demo-mode flag, and nothing else.
//
// Kept in its own dependency-free module on purpose: the app shell and the
// "this is demo data" banner both need to know whether demo mode is on, and
// neither should drag the environmental-health data layer into the initial
// bundle to find out. Everything that actually *writes* demo records lives in
// demoData.js, which is loaded on demand.
// ─────────────────────────────────────────────────────────────────────────────

const OFF_VALUES = ["off", "false", "0", "no"];

const raw = String(process.env.REACT_APP_DEMO_MODE ?? "").trim().toLowerCase();

/**
 * ON unless explicitly switched off, so a fresh visit to the deployed link is
 * never a blank app.
 *
 * For a real deployment, put
 *
 *     REACT_APP_DEMO_MODE=off
 *
 * in `.env` (or in the build environment) and rebuild. That is the whole
 * switch: the seed never runs, the banner never renders, and every demo-only
 * affordance disappears. Records already on a device are not touched — use
 * "Clear all data" on the Data & privacy screen for that.
 */
export const DEMO_MODE = raw === "" ? true : !OFF_VALUES.includes(raw);

/**
 * Bumped whenever the sample set changes. Stored alongside the module config so
 * the auto-seed runs exactly once per device per version and can never
 * double-seed, however many times the app is opened.
 *
 * Raising it replaces the sample set on next open: the old demo-flagged records
 * are removed and the new ones written. Real records are never touched.
 *
 * v3 — spread the hazard sites along the coast so computed risk spans medium
 *      and high instead of 14-of-15 high, and made every sample coordinate
 *      deterministic so two devices show the same dashboard.
 */
export const DEMO_SEED_VERSION = 3;

/** Every seeded record carries this, so demo and real data are never mixed up. */
export const DEMO_FLAG = "demo";
